export default function priceCalculator(items) {
  return items
    .reduce((total, item) => (total += parseFloat(item.price)), 0)
    .toFixed(2)
}
